module.exports = __webpack_public_path__ + "img/59.3a7ffd4c.jpg";